import React from "react";

interface TextAreaProps {
  name: string;
  label?: string;
  id?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
  className?: string;
  placeholder?: string;
  value?: any;
  rows?: number;
  onBlur?: (_: any, name: string) => void;
  onKeyDown?: (_: any, name: string) => void;
  onChange?: (_: any, name: string) => void;
}

const TextArea: React.FC<TextAreaProps> = ({
  label, id, disabled, name, required, error, errorMessage, className, placeholder, value, rows = 5, onBlur, onKeyDown, onChange
}) => {
  return (
    <>
      <textarea
        id={id}
        name={name}
        rows={rows}
        className={`form-control ${error && 'is-invalid'} ${className || ""}`}
        placeholder={placeholder}
        value={value}
        autoComplete="off"
        onBlur={(e) => onBlur && onBlur(e, name)}
        onKeyDown={(e) => onKeyDown && onKeyDown(e, name)}
        onChange={(e) => onChange && onChange(e, name)}
        disabled={disabled}
        required={required}
      />
      {label && <label htmlFor={id}>{label} {required && <span className="text-danger">*</span>}</label>}
      {
        error &&
        <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback">
          <div data-field={id} data-validator="notEmpty">
            {errorMessage}
          </div>
        </div>
      }
    </>
  )
};

export default TextArea;

